import { render, staticRenderFns } from "./BidLotInput.vue?vue&type=template&id=453d57c4&scoped=true&"
import script from "./BidLotInput.vue?vue&type=script&lang=js&"
export * from "./BidLotInput.vue?vue&type=script&lang=js&"
import style0 from "./BidLotInput.vue?vue&type=style&index=0&id=453d57c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d57c4",
  null
  
)

export default component.exports